import { render } from "./VideoBannerThree.vue?vue&type=template&id=2fedeb93"
import script from "./VideoBannerThree.vue?vue&type=script&lang=js"
export * from "./VideoBannerThree.vue?vue&type=script&lang=js"

import "./VideoBannerThree.vue?vue&type=style&index=0&id=2fedeb93&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__